import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import { Home, NotFound, Config, Login, SignUp, Region, Feature, MyOwns, ConfirmReserve } from "../views/index.js";
import ApartmentDetails from "views/Apartment/ApartmentDetails/ApartmentDetails.jsx";
import ApartmentReserve from "views/Apartment/BookingApartment.jsx";
import CanceledReserve from "views/CancelResrve.jsx";
import Unpublished from "views/Apartment/Unpublished.jsx";
import ReportScreen from "../views/Report.jsx";
export const routes = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{ index: true, element: <Home /> },
			{ path: "config", label: "Config", element: <Config />, icon: "Home" },
			{ path: "region", label: "Regions", element: <Region /> },
			{ path: "features", label: "Features", element: <Feature /> },
			{ path: "owns", label: "My Owns", element: <MyOwns /> },
			{ path: "confirm-reserve", label: "Confirm Reserve", element: <ConfirmReserve /> },
			{ path: "/apartments/:id", element: <ApartmentDetails type="book" /> },
			{ path: "/apartments/owns/:id/", element: <ApartmentDetails type="own" /> },
			{ path: "/apartments/publish/:id/", element: <ApartmentDetails type="publish" /> },
			{ path: "/apartment/reserve/:id", element: <ApartmentReserve /> },
			{ path: "cancel-reserve", element: <CanceledReserve /> },
			{ path: "report", element: <ReportScreen /> },
			{ path: "unpublished", element: <Unpublished /> },
		],
	},
	{ path: "/login", element: <Login /> },
	{ path: "/signup", element: <SignUp /> },
	{ path: "*", element: <NotFound /> },
]);

export default routes;
